import React, {
  Component
} from 'react';
import {
  Dropdown,
  Icon,
  Input,
  Menu
} from 'semantic-ui-react';
import {
  ceil,
  range,
  slice,
  take,
  takeRight
} from 'lodash';

const PAGE_RANGE = 5;

const NavPages = ({ floated, itemsPerPage, pageChange, total, selected }) => {
  if (total <= 0) {
    return null;
  }

  let pages = range(ceil(total / itemsPerPage));
  let mode = pages.length > 5 ? 'complex' : 'simple';

  const Pages = {
    'simple': () => pages.map((page, index) => {
      return (
        <Menu.Item
          onClick={pageChange.bind(null, page)}
          active={page === selected} key={index} as="a" name={`${page + 1}`} />
      );
    }),
    'complex': () => {
      let display = [];
      if (selected === 0 || selected === 1) {
        display = take(pages, 5);
      } else if ((pages.length - selected - 1) === 1 || (pages.length - selected - 1) === 0) {
        display = takeRight(pages, 5);
      } else {
        display = slice(pages, selected - 2, selected + 3);
      }

      return display.map((page, index) => {

        return (
          <Menu.Item
            onClick={pageChange.bind(null, page)}
            active={page === selected} key={index} as="a" name={`${page + 1}`} />
        );
      });
    }
  };

  return (
    <Menu floated={floated} size="small" pagination>
      <Menu.Item
        style={{
          pointerEvents: selected === 0 ? 'none': 'auto'
        }}
        as="a" disabled={selected === 0} icon onClick={pageChange.bind(null, 0)}>
        <Icon name="left double angle" />
      </Menu.Item>
      <Menu.Item
        style={{ pointerEvents: selected === 0 ? 'none': 'auto' }}
        as="a" disabled={selected === 0} icon onClick={pageChange.bind(null, selected - 1)}>
        <Icon name="left angle" />
      </Menu.Item>
      {
        Pages[mode]()
      }
      {
        mode === 'complex' && (selected + PAGE_RANGE) < pages.length &&
          <Menu.Item
            onClick={pageChange.bind(null, selected + PAGE_RANGE)}> ... </Menu.Item>
      }
      {
        mode === 'complex' && (selected + PAGE_RANGE) < pages.length &&
          <Menu.Item
            onClick={pageChange.bind(null, pages.length - 1)}
            active={pages.length === selected} as="a" name={`${pages.length}`} />
      }
      <Menu.Item
        style={{ pointerEvents: selected === pages.length - 1 ? 'none': 'auto' }}
        as="a" disabled={selected === pages.length - 1} icon onClick={pageChange.bind(null, selected + 1)}>
        <Icon name="right angle" />
      </Menu.Item>
      <Menu.Item
        style={{ pointerEvents: selected === pages.length - 1 ? 'none': 'auto' }}
        as="a" disabled={selected === pages.length - 1} icon onClick={pageChange.bind(null, pages.length - 1)}>
        <Icon name="right double angle" />
      </Menu.Item>
    </Menu>
  );
};

NavPages.defaultProps = {
  floated: false,
  itemsPerPage: 10,
  pageChange: () => {
    throw new Error('must supply pageChange fn');
  },
  total: 0
};

export default NavPages;



// WEBPACK FOOTER //
// ./client/components/navigation/NavPages.js